import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useApiClientContext } from '../../contexts/apiClient';

export interface ICancelMeetingInfo {
	id: string;
	title: string;
	hostName: string;
	startDate: string;
	timeZoneId: string;
	canCancel: boolean;
	cancelDisabledReason?: string;
}

const BASE_QUERY_KEY = 'CancelMeetingInfo';

export const useCancelMeetingInfoQuery = ({ meetingId, enabled = true }: { meetingId?: string; enabled?: boolean }) => {
	const { apiClient } = useApiClientContext();

	return useQuery<ICancelMeetingInfo>({
		enabled: enabled && !!meetingId,
		queryFn: async (): Promise<ICancelMeetingInfo> => {
			const response = await fetch(`${apiClient.baseUrl}/scheduler/${encodeURIComponent(meetingId)}/cancelinfo`);

			if (!response.ok) {
				throw new Error('Meeting not found');
			}

			const result: Api.IOperationResult<ICancelMeetingInfo> = await response.json();

			if (!result.success) {
				throw new Error(result.systemMessage || 'Meeting not found');
			}

			return result.value;
		},
		queryKey: [BASE_QUERY_KEY, meetingId],
		retry: false,
	});
};
